module.exports = __webpack_public_path__ + "static/img/khk004.9a2a479a.jpg";